(function () {
  var TILE_SECTION_ID = 'et-fbt-tile-partial';

  // Cart attribution constants used by the Rebuy dynamic bundle widget — the
  // Rebuy Shopify Function applies the bundle discount based on these.
  var REBUY_SOURCE = 'Rebuy';
  var REBUY_ATTRIBUTION = 'Rebuy Dynamic Product Bundle';

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ----------------------------------------------------------------
     Money formatting derived from a Liquid-rendered probe, so output
     matches the market's currency, symbol position and separators.
     ---------------------------------------------------------------- */
  function parseMoneyProbe(probe, cents) {
    if (!probe || !cents) return null;
    var match = probe.match(/\d[\d.,'   ]*\d/);
    if (!match) return null;
    var core = match[0];
    var format = {
      prefix: probe.slice(0, match.index),
      suffix: probe.slice(match.index + core.length),
      decimal: '',
      thousands: ''
    };
    var tail = core.slice(-3);
    if (/^[.,]\d\d$/.test(tail)) {
      format.decimal = tail.charAt(0);
    }
    var head = format.decimal ? core.slice(0, -3) : core;
    var sep = head.match(/[^\d]/);
    if (sep) format.thousands = sep[0];
    return format;
  }

  function formatMoney(cents, format) {
    var value = Math.round(cents);
    var sign = value < 0 ? '-' : '';
    value = Math.abs(value);
    if (!format) return sign + (value / 100).toFixed(2);

    var whole = String(Math.floor(value / 100));
    if (format.thousands) {
      whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, format.thousands);
    }
    var out = whole;
    if (format.decimal) {
      var frac = String(value % 100);
      while (frac.length < 2) frac = '0' + frac;
      out += format.decimal + frac;
    }
    return sign + format.prefix + out + format.suffix;
  }

  // Rebuy rounds each discounted line UP to the cent, then sums. Verified
  // against the live widget in EUR: 2995 -> 2247, 1096 -> 822, 2596 -> 1947
  // (total 5016, compare-at total 11115).
  function discountedCents(priceCents, discountPercent) {
    return Math.ceil((priceCents * (100 - discountPercent)) / 100);
  }

  function fetchCompanionHandles(cfg) {
    var params =
      '?key=' + encodeURIComponent(cfg.key) +
      '&limit=' + encodeURIComponent(cfg.limit) +
      '&shopify_product_ids=' + encodeURIComponent(cfg.productId);
    var url = 'https://rebuyengine.com/api/v1/custom/id/' + encodeURIComponent(cfg.sourceId) + params;

    return fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Rebuy HTTP ' + response.status);
        return response.json();
      })
      .then(function (json) {
        // Only the product SELECTION comes from Rebuy. Prices are ignored here:
        // the API returns shop-currency values and markets can have their own
        // price lists, so all money comes from Liquid-rendered tiles instead.
        var seen = {};
        return ((json && json.data) || [])
          .filter(function (p) {
            if (!p || !p.handle || seen[p.handle]) return false;
            if (String(p.id) === cfg.productId) return false;
            seen[p.handle] = true;
            return true;
          })
          .slice(0, cfg.limit)
          .map(function (p) {
            return p.handle;
          });
      });
  }

  function fetchTile(handle) {
    var url = routesRoot() + 'products/' + handle + '?section_id=' + TILE_SECTION_ID;
    return fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-et-fbt-tile]');
      })
      .catch(function () {
        return null;
      });
  }

  function paintPrices(rootEl, format, discount) {
    var tiles = rootEl.querySelectorAll('[data-et-fbt-tile]');
    var totals = { price: 0, compare: 0 };
    var lineItems = [];

    tiles.forEach(function (tile) {
      var priceCents = parseInt(tile.dataset.priceCents, 10) || 0;
      var compareCents = parseInt(tile.dataset.compareCents, 10) || priceCents;
      var discounted = discountedCents(priceCents, discount);

      totals.price += discounted;
      totals.compare += compareCents;

      var compareEl = tile.querySelector('[data-et-fbt-tile-compare]');
      var priceEl = tile.querySelector('[data-et-fbt-tile-price]');
      if (compareEl) compareEl.textContent = formatMoney(compareCents, format);
      if (priceEl) priceEl.textContent = formatMoney(discounted, format);

      var variantId = parseInt(tile.dataset.variantId, 10);
      if (variantId) lineItems.push({ id: variantId, quantity: 1 });
    });

    var totalEl = rootEl.querySelector('[data-et-fbt-total]');
    var totalCompareEl = rootEl.querySelector('[data-et-fbt-total-compare]');
    if (totalEl) totalEl.textContent = formatMoney(totals.price, format);
    if (totalCompareEl) {
      totalCompareEl.textContent =
        totals.compare > totals.price ? formatMoney(totals.compare, format) : '';
    }

    var percent =
      totals.compare > 0 ? Math.round((1 - totals.price / totals.compare) * 100) : 0;
    rootEl.querySelectorAll('[data-et-fbt-percent-template]').forEach(function (el) {
      el.textContent = el.dataset.etFbtPercentTemplate.replace('{percent}', percent);
    });

    return lineItems;
  }

  function setupAdd(rootEl, cfg, lineItems) {
    var button = rootEl.querySelector('[data-et-fbt-add]');
    if (!button) return;
    var idleText = button.textContent.trim();

    button.addEventListener('click', function () {
      if (button.disabled) return;
      button.disabled = true;
      button.textContent = rootEl.dataset.addingText || idleText;

      // Same line properties the Rebuy widget attaches, so the Rebuy Shopify
      // Function still applies the bundle discount at checkout.
      var stamp = Date.now();
      var items = lineItems.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity,
          properties: {
            _source: REBUY_SOURCE,
            _attribution: REBUY_ATTRIBUTION,
            _widget_id: cfg.widgetId,
            _r_bp: lineItems.length + ':' + stamp
          }
        };
      });

      fetch(routesRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart/add ' + response.status);
          return response.json();
        })
        .then(function () {
          button.textContent = rootEl.dataset.addedText || idleText;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var toggle = document.querySelector('#cart-drawer-toggle');
          if (toggle) toggle.click();
          setTimeout(function () {
            button.disabled = false;
            button.textContent = idleText;
          }, 2000);
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = idleText;
        });
    });
  }

  function init(rootEl) {
    if (rootEl.hasAttribute('data-et-fbt-init')) return;
    rootEl.setAttribute('data-et-fbt-init', '');

    var key =
      rootEl.dataset.apiKey ||
      (window.Rebuy && window.Rebuy.shop && window.Rebuy.shop.api_key) ||
      '';
    if (!key || !rootEl.dataset.sourceId) return;

    var cfg = {
      key: key,
      sourceId: rootEl.dataset.sourceId,
      widgetId: rootEl.dataset.widgetId || '',
      productId: rootEl.dataset.productId || '',
      discount: parseFloat(rootEl.dataset.discount) || 0,
      limit: parseInt(rootEl.dataset.limit, 10) || 2
    };

    var tilesEl = rootEl.querySelector('[data-et-fbt-tiles]');
    if (!tilesEl) return;

    var format = parseMoneyProbe(
      rootEl.dataset.moneyProbe,
      parseInt(rootEl.dataset.moneyProbeCents, 10)
    );

    fetchCompanionHandles(cfg)
      .then(function (handles) {
        if (!handles.length) throw new Error('No companions');
        return Promise.all(handles.map(fetchTile));
      })
      .then(function (tiles) {
        var added = 0;
        tiles.forEach(function (tile) {
          if (!tile) return;
          tilesEl.appendChild(tile);
          added += 1;
        });
        if (!added) throw new Error('No tiles rendered');

        var lineItems = paintPrices(rootEl, format, cfg.discount);
        setupAdd(rootEl, cfg, lineItems);
        rootEl.removeAttribute('hidden');
      })
      .catch(function () {
        // storefront: section stays hidden
      });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-et-fbt]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-et-fbt]')) {
      initAll(event.target);
    }
  });
})();
